import appSlice from "./appSlice";
import authShop from "./authShopSlice";
import order from "./orderSlice";
import loading from "./loadingSlice";

const rootReducers = {
    app: appSlice,
    authShop: authShop,
    order: order,
    loading: loading
};

export default rootReducers;